export type Days =
    | 'sunday'
    | 'monday'
    | 'tuesday'
    | 'wednesday'
    | 'thursday'
    | 'friday'
    | 'saturday';

export enum DaysEnum {
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
}

export interface HoursOfOperation {
    open: string;
    close: string;
}

export type HoursOfOperations = Record<Days, HoursOfOperation | null>;

export const DEFAULT_HOURS_OF_OPERATION: HoursOfOperation = {
    open: '14:00:00',
    close: '02:00:00',
};

export const DEFAULT_HOURS_OF_OPERATIONS: HoursOfOperations = {
    sunday: null,
    monday: null,
    tuesday: null,
    wednesday: null,
    thursday: null,
    friday: null,
    saturday: null,
};
